/**
 * Accordion
 */

export default function Accordion() {
    const selectors = {
        'accordion' : '.js-accordion',
    };

    this.init = () => {
        this.accordion();
    };

    this.accordion = () => {
        jQuery(selectors.accordion).on('click', '.accordion .question', function(e){
            e.preventDefault();
            let $this = jQuery(this);
            if(!$this.hasClass('active')){
                $this.addClass('active').next().slideDown();
                $this.closest('.accordion').siblings().find('.answer').slideUp();
                $this.closest('.accordion').siblings().find('.question').removeClass('active');
            }else{
                $this.removeClass('active').next().slideUp();
            }

        })
    }

}
